import { AppBar } from '@material-ui/core'
import { useMemo, useState } from 'react'

import Breadcrumbs from '../../components/Breadcrumb'
import { getTranslate } from '../../localization'
import SitekeyAddHeader from './SitekeyAddHeader'
import SitekeyMainForm from './SitekeyMainForm'
import useStyles from './styles/index.styles'

const SitekeyFormEdit = () => {
  const classes = useStyles()
  const [autoCompleteLabelForEntity, setautoCompleteLabelForEntity] =
    useState<any>(null)
  const cachedLevels = useMemo(
    () => [
      {
        label: getTranslate('Sitekey'),
        link: '/sitekeys'
      },
      {
        label: getTranslate(
          autoCompleteLabelForEntity
            ? `${autoCompleteLabelForEntity.label}`
            : ''
        )
      }
    ],
    [autoCompleteLabelForEntity]
  )

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static" color="transparent">
        <Breadcrumbs
          levels={cachedLevels}
          loading={!!autoCompleteLabelForEntity ? false : true}
        />
      </AppBar>
      <div className={classes.contentContainer}>
        <SitekeyAddHeader />
        <SitekeyMainForm
          autoCompleteLabelForEntity={autoCompleteLabelForEntity}
          setautoCompleteLabelForEntity={setautoCompleteLabelForEntity}
        />
      </div>
    </div>
  )
}
export default SitekeyFormEdit
